import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FakeText } from '@totalsoft/rocket-ui';
import { COMPETENCE_ORDER_QUERY, APPROVAL_TYPES_QUERY } from '../../queries';
import { useQuery } from 'hooks/apollo';
import CompetenceOrderGeneralDataContainer from './generalData/CompetenceOrderGeneralDataContainer';
import CompetenceOrderRuleListContainer from './rules/CompetenceOrderRuleListContainer';

const CompetenceOrderContainer = ({ competenceOrderId, onChangeCompetenceOrderTitle, onRedirect }) => {
  const { data: competenceOrderData, loading } = useQuery(COMPETENCE_ORDER_QUERY, {
    variables: {
      competenceOrderId
    },
    skip: competenceOrderId === undefined || competenceOrderId === null
  });

  const { data: approvalTypes } = useQuery(APPROVAL_TYPES_QUERY);

  useEffect(() => {
    if (competenceOrderData?.competenceOrder.approvalTypeName) {
      onChangeCompetenceOrderTitle(competenceOrderData?.competenceOrder.approvalTypeName);
    }
  }, [competenceOrderData?.competenceOrder.approvalTypeName, onChangeCompetenceOrderTitle]);

  const approvalTypeLevels = useMemo(
    () => approvalTypes?.approvalType.find(item => item.approvalTypeId === competenceOrderData?.competenceOrder.approvalTypeId),
    [approvalTypes?.approvalType, competenceOrderData?.competenceOrder.approvalTypeId]
  );

  return loading ? (
    <FakeText />
  ) : (
    <>
      <CompetenceOrderGeneralDataContainer
        competenceOrderId={competenceOrderId}
        data={competenceOrderData?.competenceOrder}
        approvalTypes={approvalTypes?.approvalType || []}
        onRedirect={onRedirect}
      />
      {competenceOrderId !== null && competenceOrderId !== undefined && (
        <CompetenceOrderRuleListContainer
          data={competenceOrderData && competenceOrderData.competenceOrder ? competenceOrderData.competenceOrder.competenceOrderRules : []}
          competenceOrderId={competenceOrderData?.competenceOrder.competenceOrderId}
          siteId={competenceOrderData?.competenceOrder.siteId}
          approvalTypeLevels={approvalTypeLevels?.approvalTypeLevels || []}
        />
      )}
    </>
  );
};

CompetenceOrderContainer.propTypes = {
  competenceOrderId: PropTypes.number,
  onChangeCompetenceOrderTitle: PropTypes.func,
  onRedirect: PropTypes.func
};

export default CompetenceOrderContainer;
